// src/components/ListVariables.js

import React from "react";
import { useAuth } from "../util/auth";
import { useVariablesByOwner, useEntityTaxonomyByOwner } from "../util/db";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

function ListVariables() {
  const auth = useAuth();
  const { data: variables, status: varStatus } = useVariablesByOwner(auth.user.uid);
  const { data: bridging, status: bridgingStatus } = useEntityTaxonomyByOwner("variable", auth.user.uid);

  if (varStatus === "loading" || bridgingStatus === "loading") {
    return <CircularProgress />;
  }
  if (!variables) return null;

  // Build a map from variable.id => array of tag names
  const variableTagsMap = {};
  if (bridging) {
    bridging.forEach((row) => {
      const arr = variableTagsMap[row.entity_id] || [];
      arr.push(row.taxonomy.name);
      variableTagsMap[row.entity_id] = arr;
    });
  }

  return (
    <TableContainer component={Paper} style={{ marginTop: "2rem" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Shorthand</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Content</TableCell>
            <TableCell>Tags</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {variables.map((v) => {
            const tags = variableTagsMap[v.id] || [];
            return (
              <TableRow key={v.id}>
                <TableCell>{v.shorthand}</TableCell>
                <TableCell>{v.title}</TableCell>
                <TableCell>{v.content}</TableCell>
                <TableCell>{tags.join(", ")}</TableCell>
                <TableCell>{v.createdAt}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ListVariables;
